import React from 'react'
import Wrapper from '../../components/wrapper'
import PropTypes from 'prop-types'
import './styles.css'
import { UploadInProgress } from '../../components/restaurantPoolSchedule/uploadInProgress' 
import { FailedScheduleTable } from '../../components/restaurantPoolSchedule/failedSchedulesTable'
import { WarnScheduleTable } from '../../components/restaurantPoolSchedule/warnSchedulesTable'
import { Badge } from '../../components/restaurantPoolSchedule/badge'

export class RestaurantPoolScheduleResult extends React.Component {
  render() {
    let body

    if (this.props.isLoading) {
      body = <UploadInProgress />
    }
    else if (this.props.scheduleUploadError) {
      body = <Badge isSuccess={false} scheduleUploadError={this.props.scheduleUploadError} onServerError={this.props.onServerError} />
    } else {
      const succeeded = this.props.scheduleUploadResult.filter(r => r.status.toLowerCase() === "success")
      const failed = this.props.scheduleUploadResult.filter(r => r.status.toLowerCase() === "error")
      const warn = this.props.scheduleUploadResult.filter(r => r.status.toLowerCase() === "warn")

      body =
      <div>
        <Badge isSuccess succeeded={succeeded} />
        <div>
          {failed && failed.length > 0 ? <FailedScheduleTable schedules={failed} validScheduleRows={this.props.validScheduleRows} /> : null}
        </div>
        <div>
          {warn && warn.length > 0 ? <WarnScheduleTable schedules={warn} validScheduleRows={this.props.validScheduleRows} /> : null}
        </div>
      </div>
    }

    return <Wrapper title={'Pool Schedule Upload Result'} >
      <div className="restaurant-pool-schedule upload-success">
        { body }
      </div>
    </Wrapper>
  }
}

RestaurantPoolScheduleResult.propTypes = {
  validScheduleRows: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
  scheduleUploadError: PropTypes.string,
  scheduleUploadResult:  PropTypes.array,

  onServerError: PropTypes.func.isRequired
}

export default RestaurantPoolScheduleResult



// WEBPACK FOOTER //
// ./src/containers/restaurant-pool-schedule/RestaurantPoolScheduleResult.js